// components/EmailInfoText.jsx
import React from "react";

// Reusable highlight component
const TextHighlight = ({ children }) => (
  <span className="text-secondary">{children}</span>
);

export const InfoTextHighlight = ({ instructions }) => {
  // Default instructions if none provided
  const defaultInstructions = [
    { text: "Enter your ", highlight: false },
    { text: "Email", highlight: true },
    { text: " to ", highlight: false },
    { text: "register for a new tour", highlight: true },

    { text: " or to  ", highlight: false },
    { text: "update your existing tour details", highlight: true },
    { text: ".", highlight: false },
  ];

  const content = instructions || defaultInstructions;

  return (
    <>
      {content.map((item, idx) =>
        item.highlight ? (
          <TextHighlight key={idx}>{item.text}</TextHighlight>
        ) : (
          <span key={idx}>{item.text}</span>
        ),
      )}
    </>
  );
};

export default InfoTextHighlight;
